/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Ui_Thresholds_Max_BpmInputs */

const en_ui_thresholds_max_bpm = /** @type {(inputs: Ui_Thresholds_Max_BpmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Max ${i?.value} bpm`)
};

const de_ui_thresholds_max_bpm = /** @type {(inputs: Ui_Thresholds_Max_BpmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Max. ${i?.value} bpm`)
};

/**
* | output |
* | --- |
* | "Max {value} bpm" |
*
* @param {Ui_Thresholds_Max_BpmInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_thresholds_max_bpm = /** @type {((inputs: Ui_Thresholds_Max_BpmInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Thresholds_Max_BpmInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_thresholds_max_bpm(inputs)
	return de_ui_thresholds_max_bpm(inputs)
});